define([
  'immutable',
  'es6!sumo/util',
  'es6!launcher/actions/SubscribersActions',
], (Immutable, Util, Actions) => {
  const initialState = Immutable.Map({
    all: Immutable.List(),
    subscriberLists: Immutable.List(),
    subscriberList: Immutable.Map(),
    subscriberListContacts: Immutable.List(),
    error: null,
    loading: false,
    pagination: Immutable.Map(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.REQUEST_SUBSCRIBER_LISTS] = state => state.set('loading', true);

  actionHandlers[Actions.REQUEST_SUBSCRIBER_LIST] = state => (
    state.merge({
      loading: true,
      error: null,
      subscriberList: Immutable.Map(),
    })
  );

  actionHandlers[Actions.REQUEST_UPDATE_SUBSCRIBER_LIST] = state => (
    state.merge({
      loading: true,
      error: null,
    })
  );

  actionHandlers[Actions.ERROR_SUBSCRIBER_LISTS] = (state, action) => (
    state.merge(Immutable.fromJS({
      loading: false,
      error: action.data,
    }))
  );

  actionHandlers[Actions.RECEIVE_ALL_SUBSCRIBER_LISTS] = (state, action) => (
    state.merge(Immutable.fromJS({
      all: Immutable.fromJS(action.lists),
    }))
  );

  actionHandlers[Actions.RECEIVE_SUBSCRIBER_LISTS] = (state, action) => (
    state.merge(Immutable.fromJS({
      loading: false,
      pagination: action.data.pagination,
      subscriberLists: action.data.subscriberLists,
      error: null,
    }))
  );

  actionHandlers[Actions.RECEIVE_SUBSCRIBER_LIST] = (state, action) => (
    state.merge(Immutable.fromJS({
      loading: false,
      subscriberList: action.data.subscriberList,
      error: null,
    }))
  );

  actionHandlers[Actions.RECEIVE_SUBSCRIBER_LIST_CONTACTS] = (state, action) => (
    state.merge(Immutable.fromJS({
      loading: false,
      subscriberList: action.data.subscriberList,
      subscriberListContacts: action.data.subscriberListContacts,
      error: null,
      pagination: action.data.pagination,
    }))
  );

  return Util.createReducer(initialState, actionHandlers);
});
